<template>
  <nav class="global-navigation footer">
    <ul class="global-navigation__list">
      <li
        class="global-navigation__list__item"
        :class="{ 'global-navigation__list__item--current': current === 'home' }"
      >
        <router-link class="global-navigation__list__item-link" to="/home">
          <navigation-home-icon-parts class="global-navigation__list__item-icon" />
          <span class="global-navigation__list__item-name">{{ $tc('navigation.home') }}</span>
        </router-link>
      </li>
      <li
        class="global-navigation__list__item"
        :class="{ 'global-navigation__list__item--current': current === 'race' }"
      >
        <router-link class="global-navigation__list__item-link" to="/">
          <navigation-race-icon-parts class="global-navigation__list__item-icon" />
          <span class="global-navigation__list__item-name">{{ $tc('navigation.race') }}</span>
        </router-link>
      </li>
      <li
        class="global-navigation__list__item"
        :class="{ 'global-navigation__list__item--current': current === 'standings' }"
      >
        <router-link class="global-navigation__list__item-link" to="/standings">
          <navigation-standings-icon-parts class="global-navigation__list__item-icon" />
          <span class="global-navigation__list__item-name">{{ $tc('navigation.standings') }}</span>
        </router-link>
      </li>
      <li
        class="global-navigation__list__item"
        :class="{ 'global-navigation__list__item--current': current === 'mission' }"
      >
        <router-link class="global-navigation__list__item-link" to="/mission">
          <navigation-mission-icon-parts class="global-navigation__list__item-icon" />
          <span class="global-navigation__list__item-name">{{ $tc('navigation.mission') }}</span>
        </router-link>
      </li>
      <li
        class="global-navigation__list__item"
        :class="{ 'global-navigation__list__item--current': current === 'link' }"
      >
        <router-link class="global-navigation__list__item-link" to="/link">
          <navigation-link-icon-parts class="global-navigation__list__item-icon" />
          <span class="global-navigation__list__item-name">{{ $tc('navigation.links') }}</span>
        </router-link>
      </li>
      <li
        class="global-navigation__list__item"
        :class="{ 'global-navigation__list__item--current': current === 'mypage' }"
      >
        <router-link class="global-navigation__list__item-link" to="/mypage">
          <NavigationMyPageIconParts class="global-navigation__list__item-icon" />
          <span class="global-navigation__list__item-name">{{ $tc('navigation.mypage') }}</span>
        </router-link>
      </li>
    </ul>
  </nav>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'
import NavigationHomeIconParts from '@/components/common/GlobalNavigation/GlobalNavigationPane/parts/NavigationHomeIconParts.vue'
import NavigationRaceIconParts from '@/components/common/GlobalNavigation/GlobalNavigationPane/parts/NavigationRaceIconParts.vue'
import NavigationStandingsIconParts from '@/components/common/GlobalNavigation/GlobalNavigationPane/parts/NavigationStandingsIconParts.vue'
import NavigationLinkIconParts from '@/components/common/GlobalNavigation/GlobalNavigationPane/parts/NavigationLinkIconParts.vue'
import NavigationMyPageIconParts from '@/components/common/GlobalNavigation/GlobalNavigationPane/parts/NavigationMyPageIconParts.vue'
import NavigationMissionIconParts from '@/components/common/GlobalNavigation/GlobalNavigationPane/parts/NavigationMissionIconParts.vue'

/**
 * グローバルナビゲーション
 */
export default defineComponent({
  name: 'GlobalNavigationPane',
  components: {
    NavigationMissionIconParts,
    NavigationHomeIconParts,
    NavigationRaceIconParts,
    NavigationStandingsIconParts,
    NavigationLinkIconParts,
    NavigationMyPageIconParts,
  },
  props: {
    /**
     * カレント表示指定
     */
    current: {
      type: String,
      default: '',
    },
  },
})
</script>

<style lang="scss" scoped>
.global-navigation {
  position: relative;
  width: 100%;
  background: #fff;
  filter: drop-shadow(0 -1px 0 rgba(0, 0, 0, 0.03));
  z-index: 10;

  &__list {
    display: flex;
    justify-content: space-around;
    width: 100%;

    &__item {
      flex-grow: 0;
      flex-shrink: 0;

      &-link {
        display: flex;
        flex-flow: column nowrap;
        align-items: center;
        justify-content: center;
        width: 100%;
        min-width: 38px;
        height: $globalNavigationHeight;
        border-top: 2px solid #fff;
      }

      &-icon {
        color: $black;
        opacity: 0.3;
      }

      &-name {
        margin-top: 2px;
        font-size: 10px;
        color: $gray75;
        line-height: 1.4;
        white-space: nowrap;
      }

      &--current {
        .global-navigation__list__item-link {
          border-top-color: #000;
        }

        .global-navigation__list__item-icon {
          opacity: 1;
        }

        .global-navigation__list__item-name {
          font-weight: 500;
          color: $black;
        }
      }
    }
  }

  .disabled {
    pointer-events: none;
  }
}
</style>
